// Klaviyo modal accessibility patch.
// Exposes a11yHideTopLevelElements / a11yShowTopLevelElements on window so the
// Klaviyo modal lifecycle can toggle aria-hidden on sibling top-level nodes
// without trapping screen readers inside the modal.

(function () {
  const isAriaHiddenTrue = ($el) => {
    const ariaHiddenValue = $el ? $el.getAttribute('aria-hidden') : null;
    return ariaHiddenValue === 'true';
  };

  const isHTMLElement = (node) => node.nodeType === Node.ELEMENT_NODE;

  const isModal = (node) => {
    if (node.children.length !== 1) return false;
    return Array.from(node.children[0].classList).some((cls) =>
      cls.startsWith('kl-private-reset')
    );
  };

  const getTopLevelDomElements = () =>
    Array.from(document.body.children).filter((node) => {
      if (!isHTMLElement(node)) return false;
      const tagName = node.tagName.toLowerCase();
      return (
        tagName !== 'script' &&
        tagName !== 'link' &&
        tagName !== 'iframe' &&
        tagName !== 'style' &&
        !isModal(node)
      );
    });

  window.a11yHideTopLevelElements = () => {
    getTopLevelDomElements().forEach(($el) => {
      if (!isAriaHiddenTrue($el)) {
        $el.setAttribute('kl-aria-hidden', 'true');
        $el.setAttribute('aria-hidden', 'true');
      }
    });
  };

  window.a11yShowTopLevelElements = () => {
    getTopLevelDomElements().forEach(($el) => {
      if ($el.hasAttribute('kl-aria-hidden')) {
        $el.removeAttribute('kl-aria-hidden');
        $el.removeAttribute('aria-hidden');
      }
    });
  };
})();
